
// // This is my final code


// import React, { useEffect, useState } from "react";
// import { db } from "../firebase";
// import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc } from "firebase/firestore";
// import { ToastContainer, toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import "react-toastify/dist/ReactToastify.css";

// const TrainingManagement = () => {
//   const [trainings, setTrainings] = useState([]);
//   const [trainingName, setTrainingName] = useState("");
//   const [trainingType, setTrainingType] = useState("true_false"); // Add trainingType state
//   const [currentId, setCurrentId] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchTrainings();
//   }, []);

//   const fetchTrainings = async () => {
//     const querySnapshot = await getDocs(collection(db, "trainings"));
//     const trainingsData = querySnapshot.docs.map((doc) => ({
//       id: doc.id,
//       ...doc.data(),
//     }));
//     setTrainings(trainingsData);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       if (currentId) {
//         // Update existing training
//         const trainingDoc = doc(db, "trainings", currentId);
//         await updateDoc(trainingDoc, { name: trainingName, type: trainingType });
//         toast.success("Training updated successfully!");
//       } else {
//         // Add new training
//         await addDoc(collection(db, "trainings"), {
//           name: trainingName,
//           type: trainingType, // Save the type
//         });
//         toast.success("Training added successfully!");
//       }
//       resetForm();
//       fetchTrainings();
//     } catch (error) {
//       toast.error("Error adding/updating training: " + error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEdit = (training) => {
//     setTrainingName(training.name);
//     setTrainingType(training.type || "true_false"); // Default to true_false if type is missing
//     setCurrentId(training.id);
//   };

//   const handleDelete = async (id, name) => {
//     const confirmDelete = window.confirm(`Are you sure you want to delete "${name}"?`);
//     if (!confirmDelete) return;

//     const trainingDoc = doc(db, "trainings", id);
//     const questionsCollection = collection(db, `trainings/${id}/questions`);
//     const questionsSnapshot = await getDocs(questionsCollection);

//     const deletePromises = questionsSnapshot.docs.map(async (questionDoc) => {
//       await deleteDoc(doc(questionsCollection, questionDoc.id));
//     });

//     await Promise.all(deletePromises);
//     await deleteDoc(trainingDoc);
//     toast.success(`Training "${name}" and its questions deleted successfully!`);
//     fetchTrainings();
//   };

//   const handleManageQuestions = (trainingId, trainingType) => {
//     navigate(`/training-questions/${trainingId}`, { state: { type: trainingType } });
//   };

//   const resetForm = () => {
//     setTrainingName("");
//     setTrainingType("true_false"); // Reset type
//     setCurrentId(null);
//   };

//   return (
//     <div className="container mt-3">
//       <h2>Manage Trainings</h2>
//       <form onSubmit={handleSubmit} className="mb-3">
//         <input
//           type="text"
//           placeholder="Enter training name"
//           value={trainingName}
//           onChange={(e) => setTrainingName(e.target.value)}
//           required
//           className="form-control"
//         />
//         <label className="d-block mt-2">
//           Select Training Type:
//           <select
//             value={trainingType}
//             onChange={(e) => setTrainingType(e.target.value)}
//             className="form-select mt-2"
//           >
//             <option value="true_false">True/False</option>
//             <option value="mcq">Multiple Choice Questions (MCQ)</option>
//           </select>
//         </label>
//         <button type="submit" disabled={loading} className="btn btn-primary mt-2">
//           {loading ? "Loading..." : currentId ? "Update Training" : "Add Training"}
//         </button>
//       </form>

//       <table className="table table-striped">
//         <thead>
//           <tr>
//             <th>Training Name</th>
//             <th>Type</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {trainings.map((training) => (
//             <tr key={training.id}>
//               <td>{training.name}</td>
//               <td>{training.type === "mcq" ? "MCQ" : "True/False"}</td>
//               <td>
//                 <button
//                   onClick={() => handleEdit(training)}
//                   className="btn btn-warning btn-sm me-2"
//                 >
//                   Edit
//                 </button>
//                 <button
//                   onClick={() => handleDelete(training.id, training.name)}
//                   className="btn btn-danger btn-sm me-2"
//                 >
//                   Delete
//                 </button>
//                 <button
//                   onClick={() => handleManageQuestions(training.id, training.type)}
//                   className="btn btn-info btn-sm"
//                 >
//                   Manage Questions
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
//     </div>
//   );
// };

// export default TrainingManagement;




// import React, { useEffect, useState } from "react";
// import { db } from "../firebase";
// import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc, query, orderBy, limit, where } from "firebase/firestore";
// import { ToastContainer, toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import "react-toastify/dist/ReactToastify.css";

// const TrainingManagement = () => {
//   const [trainings, setTrainings] = useState([]);
//   const [trainingName, setTrainingName] = useState("");
//   const [trainingType, setTrainingType] = useState("true_false");
//   const [currentId, setCurrentId] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [loadingAction, setLoadingAction] = useState(null); // For specific action loading states
//   const [searchQuery, setSearchQuery] = useState("");
//   const [page, setPage] = useState(1);
//   const itemsPerPage = 15;  // Limit trainings per page
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchTrainings();
//   }, [page, searchQuery]);

//   const fetchTrainings = async () => {
//     setLoading(true);

//     try {
//       let q = query(collection(db, "trainings"), orderBy("name"), limit(itemsPerPage));

//       // If a search query exists, add a filter
//       if (searchQuery) {
//         q = query(q, where("name", ">=", searchQuery), where("name", "<=", searchQuery + "\uf8ff"));
//       }

//       const querySnapshot = await getDocs(q);
//       const trainingsData = querySnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       setTrainings(trainingsData);
//     } catch (error) {
//       toast.error("Error fetching trainings: " + error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoadingAction("submit");

//     try {
//       if (currentId) {
//         // Update existing training
//         const trainingDoc = doc(db, "trainings", currentId);
//         await updateDoc(trainingDoc, { name: trainingName, type: trainingType });
//         toast.success("Training updated successfully!");
//       } else {
//         // Add new training
//         await addDoc(collection(db, "trainings"), {
//           name: trainingName,
//           type: trainingType,
//         });
//         toast.success("Training added successfully!");
//       }

//       resetForm();
//       fetchTrainings();
//     } catch (error) {
//       toast.error("Error adding/updating training: " + error.message);
//     } finally {
//       setLoadingAction(null);
//     }
//   };

//   const handleEdit = (training) => {
//     setTrainingName(training.name);
//     setTrainingType(training.type || "true_false");
//     setCurrentId(training.id);
//   };

//   const handleDelete = async (id, name) => {
//     const confirmDelete = window.confirm(`Are you sure you want to delete "${name}"?`);
//     if (!confirmDelete) return;

//     setLoadingAction("delete");

//     try {
//       const trainingDoc = doc(db, "trainings", id);
//       const questionsCollection = collection(db, `trainings/${id}/questions`);
//       const questionsSnapshot = await getDocs(questionsCollection);

//       const deletePromises = questionsSnapshot.docs.map(async (questionDoc) => {
//         await deleteDoc(doc(questionsCollection, questionDoc.id));
//       });

//       // Use batch operation to delete training and its questions efficiently
//       await Promise.all(deletePromises);
//       await deleteDoc(trainingDoc);
//       toast.success(`Training "${name}" and its questions deleted successfully!`);
//       fetchTrainings();
//     } catch (error) {
//       toast.error("Error deleting training: " + error.message);
//     } finally {
//       setLoadingAction(null);
//     }
//   };

//   const handleManageQuestions = (trainingId, trainingType) => {
//     navigate(`/training-questions/${trainingId}`, { state: { type: trainingType } });
//   };

//   const resetForm = () => {
//     setTrainingName("");
//     setTrainingType("true_false");
//     setCurrentId(null);
//   };

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//     setPage(1); // Reset to the first page on search
//   };

//   const handleNextPage = () => setPage(page + 1);
//   const handlePreviousPage = () => setPage(page - 1);

//   return (
//     <div className="container mt-3">
//       <h2>Manage Trainings</h2>

//       {/* Search Bar */}
//       <input
//         type="text"
//         placeholder="Search Trainings..."
//         value={searchQuery}
//         onChange={handleSearchChange}
//         className="form-control mb-3"
//       />

//       <form onSubmit={handleSubmit} className="mb-3">
//         <input
//           type="text"
//           placeholder="Enter training name"
//           value={trainingName}
//           onChange={(e) => setTrainingName(e.target.value)}
//           required
//           className="form-control"
//         />
//         <label className="d-block mt-2">
//           Select Training Type:
//           <select
//             value={trainingType}
//             onChange={(e) => setTrainingType(e.target.value)}
//             className="form-select mt-2"
//           >
//             <option value="true_false">True/False</option>
//             <option value="mcq">Multiple Choice Questions (MCQ)</option>
//           </select>
//         </label>
//         <button type="submit" disabled={loadingAction === "submit"} className="btn btn-primary mt-2">
//           {loadingAction === "submit" ? "Loading..." : currentId ? "Update Training" : "Add Training"}
//         </button>
//       </form>

//       {/* Trainings Table */}
//       <table className="table table-striped">
//         <thead>
//           <tr>
//             <th>Training Name</th>
//             <th>Type</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {trainings.map((training) => (
//             <tr key={training.id}>
//               <td>{training.name}</td>
//               <td>{training.type === "mcq" ? "MCQ" : "True/False"}</td>
//               <td>
//                 <button
//                   onClick={() => handleEdit(training)}
//                   className="btn btn-warning btn-sm me-2"
//                 >
//                   Edit
//                 </button>
//                 <button
//                   onClick={() => handleDelete(training.id, training.name)}
//                   className="btn btn-danger btn-sm me-2"
//                 >
//                   Delete
//                 </button>
//                 <button
//                   onClick={() => handleManageQuestions(training.id, training.type)}
//                   className="btn btn-info btn-sm"
//                 >
//                   Manage Questions
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Pagination Controls */}
//       <div className="d-flex justify-content-between">
//         <button
//           className="btn btn-secondary"
//           onClick={handlePreviousPage}
//           disabled={page === 1 || loading}
//         >
//           Previous
//         </button>
//         <button
//           className="btn btn-secondary"
//           onClick={handleNextPage}
//           disabled={trainings.length < itemsPerPage || loading}
//         >
//           Next
//         </button>
//       </div>

//       <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
//     </div>
//   );
// };

// export default TrainingManagement;
























import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc, query, orderBy, limit, where } from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

const TrainingManagement = () => {
  const [trainings, setTrainings] = useState([]);
  const [trainingName, setTrainingName] = useState("");
  const [trainingType, setTrainingType] = useState("true_false");
  const [currentId, setCurrentId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingAction, setLoadingAction] = useState(null); // For specific action loading states
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const itemsPerPage = 50;  // Limit trainings per page
  const navigate = useNavigate();

  useEffect(() => {
    fetchTrainings();
  }, [page, searchQuery]);

  const fetchTrainings = async () => {
    setLoading(true);

    try {
      let q = query(collection(db, "trainings"), orderBy("name"), limit(itemsPerPage));

      // If a search query exists, add a filter
      if (searchQuery) {
        q = query(q, where("name", ">=", searchQuery), where("name", "<=", searchQuery + "\uf8ff"));
      }

      const querySnapshot = await getDocs(q);
      const trainingsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setTrainings(trainingsData);
    } catch (error) {
      toast.error("Error fetching trainings: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingAction("submit");

    try {
      if (currentId) {
        // Update existing training
        const trainingDoc = doc(db, "trainings", currentId);
        await updateDoc(trainingDoc, { name: trainingName, type: trainingType });
        toast.success("Training updated successfully!");
      } else {
        // Add new training
        await addDoc(collection(db, "trainings"), {
          name: trainingName,
          type: trainingType,
        });
        toast.success("Training added successfully!");
      }

      resetForm();
      fetchTrainings();
    } catch (error) {
      toast.error("Error adding/updating training: " + error.message);
    } finally {
      setLoadingAction(null);
    }
  };

  const handleEdit = (training) => {
    setTrainingName(training.name);
    setTrainingType(training.type || "true_false");
    setCurrentId(training.id);
  };

  const handleDelete = async (id, name) => {
    const confirmDelete = window.confirm(`Are you sure you want to delete "${name}"?`);
    if (!confirmDelete) return;

    setLoadingAction("delete");

    try {
      const trainingDoc = doc(db, "trainings", id);
      const questionsCollection = collection(db, `trainings/${id}/questions`);
      const questionsSnapshot = await getDocs(questionsCollection);

      const deletePromises = questionsSnapshot.docs.map(async (questionDoc) => {
        await deleteDoc(doc(questionsCollection, questionDoc.id));
      });

      // Use batch operation to delete training and its questions efficiently
      await Promise.all(deletePromises);
      await deleteDoc(trainingDoc);
      toast.success(`Training "${name}" and its questions deleted successfully!`);
      fetchTrainings();
    } catch (error) {
      toast.error("Error deleting training: " + error.message);
    } finally {
      setLoadingAction(null);
    }
  };

  const handleManageQuestions = (trainingId, trainingType) => {
    navigate(`/training-questions/${trainingId}`, { state: { type: trainingType } });
  };

  const resetForm = () => {
    setTrainingName("");
    setTrainingType("true_false");
    setCurrentId(null);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(1); // Reset to the first page on search
  };

  const handleNextPage = () => setPage(page + 1);
  const handlePreviousPage = () => setPage(page - 1);

  return (
    <div className="container mt-3">
      <h2>Manage Trainings</h2>

      {/* Search Bar */}
      <input
        type="text"
        placeholder="Search Trainings..."
        value={searchQuery}
        onChange={handleSearchChange}
        className="form-control mb-3"
      />

      <form onSubmit={handleSubmit} className="mb-3">
        <input
          type="text"
          placeholder="Enter training name"
          value={trainingName}
          onChange={(e) => setTrainingName(e.target.value)}
          required
          className="form-control"
        />
        <label className="d-block mt-2">
          Select Training Type:
          <select
            value={trainingType}
            onChange={(e) => setTrainingType(e.target.value)}
            className="form-select mt-2"
          >
            <option value="true_false">True/False</option>
            <option value="mcq">Multiple Choice Questions (MCQ)</option>
            <option value="declaration">Declaration</option>  {/* New option for declaration */}
          </select>
        </label>
        <button type="submit" disabled={loadingAction === "submit"} className="btn btn-primary mt-2">
          {loadingAction === "submit" ? "Loading..." : currentId ? "Update Training" : "Add Training"}
        </button>
      </form>

      {/* Trainings Table */}
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Training Name</th>
            <th>Type</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {trainings.map((training) => (
            <tr key={training.id}>
              <td>{training.name}</td>
              <td>{training.type === "mcq" ? "MCQ" : training.type === "declaration" ? "Declaration" : "True/False"}</td>
              <td>
                <button
                  onClick={() => handleEdit(training)}
                  className="btn btn-warning btn-sm me-2"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(training.id, training.name)}
                  className="btn btn-danger btn-sm me-2"
                >
                  Delete
                </button>
                <button
                  onClick={() => handleManageQuestions(training.id, training.type)}
                  className="btn btn-info btn-sm"
                >
                  Manage Questions
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div className="d-flex justify-content-between">
        <button
          className="btn btn-secondary"
          onClick={handlePreviousPage}
          disabled={page === 1 || loading}
        >
          Previous
        </button>
        <button
          className="btn btn-secondary"
          onClick={handleNextPage}
          disabled={trainings.length < itemsPerPage || loading}
        >
          Next
        </button>
      </div>

      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
    </div>
  );
};

export default TrainingManagement;
